// extracted by mini-css-extract-plugin
module.exports = {"hidden":"styles_hidden__2ugTf","container":"styles_container__26g0L"};